import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { authMiddleware } from "~/lib/auth-middleware";
import { requireClerkCoachAuth } from "~/lib/coach-middleware";

export const getUserSharedStatusFn = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }) => {
    const { getUserSharedStatus } = await import("~/lib/server/user-shared");
    const userId = context.user.id;
    return getUserSharedStatus(userId);
  });

export const sharedOverallViewWithCoachFn = createServerFn({
  method: "POST",
})
  .middleware([authMiddleware])
  .validator(z.object({ shared: z.boolean() }))
  .handler(async ({ data, context }) => {
    const { sharedOverallViewWithCoach } =
      await import("~/lib/server/user-shared");
    const userId = context.user.id;
    return sharedOverallViewWithCoach(userId, data.shared);
  });

export const sharedGoalsOfLifeWithCoachFn = createServerFn({
  method: "POST",
})
  .middleware([authMiddleware])
  .validator(z.object({ shared: z.boolean() }))
  .handler(async ({ data, context }) => {
    const { sharedGoalsOfLifeWithCoach } =
      await import("~/lib/server/user-shared");
    const userId = context.user.id;
    return sharedGoalsOfLifeWithCoach(userId, data.shared);
  });

export const getClientSharedStatusFn = createServerFn({ method: "GET" })
  .middleware([requireClerkCoachAuth])
  .validator(z.object({ userId: z.string().uuid() }))
  .handler(async ({ data, context }) => {
    const { getClientSharedStatusForCoach } =
      await import("~/lib/server/user-shared");
    return getClientSharedStatusForCoach(context.coach.id, data.userId);
  });
